import { action, payload } from 'ts-action'
import { IIndustry } from 'models/Industry'
import { IError, IPayload } from 'models/Global'

export const IndustriesFetching = action('IndustriesFetching', payload<boolean>())

export const GetIndustries = action('GetIndustries', payload<IPayload<IIndustry[]>>())

export const GetIndustriesErrors = action('GetIndustriesErrors', payload<IError>())
